import './ContactPage.css';
import { Helmet } from 'react-helmet';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmailIcon from '@mui/icons-material/Email';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Header from '../../components/header/Header';
import OrderCard from '../../components/OrderCard/OrderCard';
import ContactForm from '../../components/ContactForm/ContactForm';

const ContactPage = ({ headers, ordering, theme }) => {
  return (
    <div>
      <Helmet>
        <title>Contact Scisco Genetics</title>
        <meta
          name='description'
          content='Reach out to Scisco Genetics for any questions or to get a quote for service or kits'
        />
      </Helmet>
      <Header header={headers.filter((header) => header.key === 'contact')} />
      <div className='contact-container'>
        <section id='contact-info'>
          <h1 className='main-header'>Scisco Genetics</h1>
          <p className='about'>
            Scisco Genetics Inc. is committed to providing the highest possible
            standard of testing to our clients. Therefore, we have implemented a
            quality assurance program to ensure continuous improvement in our
            performance and accurate and reliable test results for our
            customers.
          </p>
          <div>
            <section className='contact-section'>
              <div className='icon'>
                <LocationOnIcon sx={{ color: 'var(--orange)' }} />
              </div>
              <a
                className='contact-info'
                href='https://www.google.com/maps/search/?api=1&query=10700%20Meridian%20Ave%20N%20STE%20504%2C%20Seattle%2C%20WA%2098133'
                target='_blank'
                rel='noreferrer'
              >
                10700 Meridian Ave N STE 504, Seattle, WA 98133
              </a>
              
            </section>
            <section className='contact-section'>
              <div className='icon'>
                <PhoneInTalkIcon sx={{ color: 'var(--orange)' }} />
              </div>
              <a href='tel: 888-827-9603' className='contact-info'>
                +1.888.827.9603
              </a>
            </section>
            <section className='contact-section'>
              <div className='icon'>
                <EmailIcon sx={{ color: 'var(--orange)' }} />
              </div>
              <a
                href='mailto: info@sciscogenetics.com'
                className='contact-info'
              >
                info@sciscogenetics.com
              </a>
            </section>
            <section className='contact-section'>
              <div className='icon'>
                <CalendarMonthIcon sx={{ color: 'var(--orange)' }} />
              </div>
              <p className='contact-info'>Mon-Fri: 9AM-5PM PST</p>
            </section>
          </div>
        </section>
        <iframe
          title="Scisco Genetics location map"
          className="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13695.965795225475!2d-122.33346832821553!3d47.70351481687502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54901153637003d9%3A0x3e29f0886817ec5f!2sParking%20lot%2C%2010700%20Meridian%20Ave%20N%20%23504%2C%20Seattle%2C%20WA%2098133!5e0!3m2!1sen!2sus!4v1746549092885!5m2!1sen!2sus"
          width="520"
          height="700"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade">
        </iframe>
        {/* <a
          href='https://www.google.com/maps/search/?api=1&query=10700%20Meridian%20Ave%20N%20STE%20504%2C%20Seattle%2C%20WA%2098133'
          target='_blank'
          rel='noreferrer'
          className='map'
        >
          <img src={map} className='map' alt='map' />
        </a> */}
      </div>
      <div className='ordering-container' id='order' style={{ scrollMarginTop: '40px' }}>
        <h2 className='secondary-header ordering-title'>Service and Kit Ordering</h2>
        <div className='order-stripe'>
          <OrderCard ordering={ordering} />
        </div>
      </div>
      <section className='contact-form' id='contact-form'>
        <ContactForm theme={theme} />
      </section>
    </div>
  );
};

export default ContactPage;
